export default "__VITE_ASSET__ChZAzPT3__"